// https://shopify.dev/docs/themes/architecture/templates
import { z } from "zod/v4";

import type { KnownBlock } from "@slack/web-api";

import { IntelligemsSlackChannel } from "../schemas/intelligems";

export const ShopifyTemplateType = [
  "",
  "404",
  "article",
  "blog",
  "cart",
  "collection",
  // "customers/account",
  // "customers/activate_account",
  // "customers/addresses",
  // "customers/login",
  // "customers/order",
  // "customers/register",
  // "customers/reset_password",
  // "gift_card.liquid",
  "index",
  "list-collections",
  "page",
  "password",
  "product",
  // "robots.txt.liquid",
  "search",
  // "metaobject",
] as const;

export type ShopifyTemplateTypeType = (typeof ShopifyTemplateType)[number];

export interface ShopifyTemplate {
  directory?: string;
  name?: ShopifyTemplateTypeType;
  suffix?: string;
}

export const ShopifyBulkOrderDownloadDtoSchema = z.object({
  startDatetime: z.string().optional(),
  endDatetime: z.string().optional(),
});

export type ShopifyBulkOrderDownloadDto = z.infer<
  typeof ShopifyBulkOrderDownloadDtoSchema
>;

export const ShopifyBulkOperationDtoSchema = z.object({
  id: z.string(),
  status: z.string(),
  type: z.string(),
  existing: z.boolean(),
});

export type ShopifyBulkOperationDto = z.infer<
  typeof ShopifyBulkOperationDtoSchema
>;

export const StaffShopifyBulkOperationDtoSchema = z.object({
  id: z.string(),
  status: z.string(),
  type: z.string(),
});

export type StaffShopifyBulkOperationDto = z.infer<
  typeof StaffShopifyBulkOperationDtoSchema
>;

export type SlackShopifyStepStatus =
  | "pending"
  | "started"
  | "finished"
  | "failed";

export type ShopifyBulkOperationSlackStepMetadata = Record<
  SlackShopifyStep,
  SlackShopifyStepStatus
>;

export type ShopifyBulkOperationType = "bulkOrderDownload";
export type ShopifyBulkOrderOperationMetadata = {
  type: "bulkOrderDownload";
  from: string;
  to: string;
};

export type SlackSteppedOperationMetadata = ShopifyBulkOrderOperationMetadata;

export interface SlackStepMessage {
  id: string;
  shopId: string;
  channel: IntelligemsSlackChannel;

  stepConfig: SlackStepConfig;
  operation?: SlackSteppedOperationMetadata;

  currentStep: SlackShopifyStep;
  status: SlackShopifyStepStatus;

  appendBlocks?: KnownBlock[];
  prependLines?: string[];
  appendLines?: string[];
}

export type SlackStepProps = {
  text: string;
  dependsOn: SlackShopifyStep[];
};

export type SlackShopifyStep = "queryShopify" | "processing" | "finalized";
export type SlackStepConfig = Record<SlackShopifyStep, SlackStepProps>;
export type SlackSteppedStepsMetadata = Record<
  SlackShopifyStep,
  SlackShopifyStepStatus
>;
